import * as fromDatatype from '../datatype-library/index';

export interface app_ui_mst_launcher_app_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  sort_code: fromDatatype.VarcharDatatypeInterface;
  target_url: fromDatatype.TextDatatypeInterface;
  applet_hdr_guid: fromDatatype.GuidDataFieldInterface;
  tenant_guid: fromDatatype.GuidDataFieldInterface;
  panel_guid: fromDatatype.GuidDataFieldInterface;
  widget_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  link_type: fromDatatype.VarcharDatatypeInterface;
  link_role_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class app_ui_mst_launcher_app_hdr_RowClass
  implements app_ui_mst_launcher_app_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  sort_code: fromDatatype.VarcharDatatypeInterface;
  target_url: fromDatatype.TextDatatypeInterface;
  applet_hdr_guid: fromDatatype.GuidDataFieldInterface;
  tenant_guid: fromDatatype.GuidDataFieldInterface;
  panel_guid: fromDatatype.GuidDataFieldInterface;
  widget_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  link_type: fromDatatype.VarcharDatatypeInterface;
  link_role_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
